import React, { useContext, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

import { ShootSelectionContext } from "../AppContext";

const ShootSelector = () => {
  const [setSelectedProduct, timeslots, setTimeslotChosen, timeslotsLoaded] =
    useContext(ShootSelectionContext);

  const continueToDetails = async () => {
    setTimeslotChosen(true);
  };

  return (
    <div className="timeslot-selector">
      <p>
        Book one of the most magical photo shoots of the year with Little
        Munchkin Photography.
        <br />
        <br />A non-refundable £20 deposit is required to book a session.
      </p>
      <br />
      <p>Choose your session below:</p>
      <div>
        {!timeslotsLoaded ? (
          <p>Loading...</p>
        ) : timeslots.length > 0 ? (
          <Fragment>
            <FontAwesomeIcon className="caret-down" icon={faCaretDown} />
            <select
              onChange={(e) => setSelectedProduct(JSON.parse(e.target.value))}
            >
              {timeslots &&
                timeslots
                  .sort((a, b) =>
                    a.order_id > b.order_id
                      ? 1
                      : b.order_id > a.order_id
                      ? -1
                      : 0
                  )
                  .map((timeslot) => (
                    <option key={timeslot._id} value={JSON.stringify(timeslot)}>
                      {timeslot.name}
                    </option>
                  ))}
            </select>
          </Fragment>
        ) : (
          <p>SOLD OUT</p>
        )}
      </div>
      {timeslotsLoaded && timeslots.length > 0 && (
        <button onClick={(e) => continueToDetails()}>Continue</button>
      )}
      <p style={{ fontSize: "24px", fontWeight: "600" }}>
        <br />
        Total Price - £75
      </p>
      <p>
        <br />
        * The sessions will be half an hour long
        <br />
        <br />
        * You will recieve 5 digital images
        <br />
        <br />
        * Additional images and prints can be discussed and purchased separately
        <br />
        <br />
        * There will be 3 different magical themes
        <br />
        <br />
        * Sessions are not suitable for newborn babies
        <br />
        <br />
        * Each theme can fit up to 4 children
        <br />
        <br />
        * If children are from multiple families, the studio can only accomodate
        up to two supervising adults
        <br />
        <br />
        * The studio will be sterilised between each session
        <br />
        <br />
        * If anyone attending the shoot has any COVID-19 symptoms, please
        message me to cancel or rearrange your shoot
        <br />
        <br />* You will recieve a £20 gift voucher to use towards any photo
        shoot in January or February 2022 (cannot be used in conjunction with
        any other offer)
      </p>
    </div>
  );
};

export default ShootSelector;
